"use client";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const faqs = [
  {
    question: "¿Hay mínimo de producción?",
    answer:
      "Sí, trabajamos con un mínimo de 50 unidades por producto. Para proyectos especiales o volúmenes mayores, podemos ajustar condiciones y plazos.",
  },
  {
    question: "¿Qué tiempos de entrega manejan?",
    answer:
      "El tiempo estándar es de 3 a 4 semanas desde la aprobación del pedido y el diseño. Para urgencias o volúmenes grandes, consultá y evaluamos opciones express.",
  },
  {
    question: "¿Qué opciones de personalización hay?",
    answer:
      "Las más comúnmente pedidas son hot stamping y bajo relieve. Cada técnica tiene características únicas; te asesoramos según tu logo, presupuesto y resultado deseado.",
  },
  {
    question: "¿Hacen packaging con mi marca?",
    answer:
      "Sí, podemos personalizar tags, fajas, sobres, estuches y blisters con tu logo y diseño. El packaging refuerza la experiencia de marca de principio a fin.",
  },
  {
    question: "¿Cómo se cotiza?",
    answer:
      "La cotización depende del producto, cantidad, técnica de personalización y packaging. Escribinos con los detalles de tu proyecto y te armamos un presupuesto a medida.",
  },
  {
    question: "¿Trabajan con clientes fuera de Argentina?",
    answer:
      "Sí, realizamos envíos internacionales desde nuestra planta de Argentina y España.",
  },
];

export default function FaqAccordion() {
  return (
    <section
      id="faq"
      className="bg-[color:var(--color-white)] py-[clamp(56px,7vw,120px)] scroll-mt-[88px] md:scroll-mt-[104px]"
    >
      <div className="px-[clamp(16px,2.7vw,52px)]">
        <h2 className="text-[clamp(28px,4.2vw,64px)] leading-[1.1] font-[800] text-[color:var(--color-black)]">
          FAQ<span className="text-[color:var(--color-red)]">.</span>
        </h2>
        <Accordion
          type="single"
          collapsible
          className="mt-[clamp(26px,3vw,60px)] border-t border-[color:var(--color-divider)]"
        >
          {faqs.map((item, index) => (
            <AccordionItem
              key={item.question}
              value={`item-${index}`}
              className="border-b border-[color:var(--color-divider)]"
            >
              <AccordionTrigger>{item.question}</AccordionTrigger>
              <AccordionContent>{item.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
